/* -------------------------------------------------------------------------- *
 * Toggle Display Buttons *
 * -------------------------------------------------------------------------- *
 * Toggle creates
 *
 *
 * Example markup:
 * <button class="js-toggle" aria-controls="js-1" aria-expanded="false">
 *     Click to Toggle!
 * </button>
 * <div id="js-1" aria-hidden="true"> ... </div>
 */

const groups_arr = [];

class ToggleButton {
    constructor(el) {
        // Use ARIA attributes for settings
        const aria_expanded = el.getAttribute('aria-expanded');
        const aria_controls = el.getAttribute('aria-controls');
        const button_group = el.getAttribute('data-group');

        // Object
        this.el = el;
        this.toggled = aria_expanded === 'true';
        this.target_el = document.getElementById(aria_controls);

        if (button_group !== undefined) {
            this.group = button_group;

            // Add object to group array
            groups_arr[this.group] = groups_arr[this.group] || [];
            groups_arr[this.group].push(this);
        }

        // Show/hide content on click
        this.el.addEventListener('click', () => this.toggleItem());
    }

    toggleItem() {
        // Check for button group
        if (this.group) {
            // Close open buttons in the same group
            groups_arr[this.group].forEach((button) => {
                if (button !== this && button.toggled === true) {
                    button.toggleItem();
                }
            });
        }

        // Update button state
        this.el.classList.toggle('is-toggled');
        this.el.setAttribute('aria-expanded', !this.toggled);

        // Update content state
        this.target_el.classList.toggle('is-toggled');
        this.target_el.setAttribute('aria-hidden', this.toggled);

        // Update object state
        this.toggled = !this.toggled;
    }
}

/* ------------- *
 * Module Export *
 * ------------- */

const Toggle = {
    init() {
        const buttons = document.querySelectorAll('.js-toggle');
        const button_arr = Array.from(buttons);
        button_arr.forEach((el) => new ToggleButton(el));
    },
};

export default Toggle;
